import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  ITINERARY_SUPPLIER_FOOD_PATH,
  NEW_ITINERARY_SUPPLIER_FOOD_PATH,
} from '../../../../config/paths';
import { ITINERARY_SUPPLIER_FOOD_COLUMNS } from '../../../../config/columns';

import {
  clearItinerarySupplierFoods,
  getItinerarySupplierFoods,
} from '../../../../actions/food/ItinerarySupplierFood';

export const Suppliers = ({
  breadcrumbs,
  itinerarySupplierFoods,
  loading,
  dispatchGetItinerarySupplierFoods,
  dispatchClearItinerarySupplierFoods,
}) => {
  useLayoutEffect(() => () => dispatchClearItinerarySupplierFoods(), []);

  const data = itinerarySupplierFoods.get('content') || [];
  const pages = itinerarySupplierFoods.get('totalPages') || null;
  const defaultPageSize =
    itinerarySupplierFoods.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Lista de Alimentaciones por Proveedor"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_ITINERARY_SUPPLIER_FOOD_PATH}
      tableStructure={{
        columns: ITINERARY_SUPPLIER_FOOD_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetItinerarySupplierFoods,
        modelPath: ITINERARY_SUPPLIER_FOOD_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetItinerarySupplierFoods: getItinerarySupplierFoods,
  dispatchClearItinerarySupplierFoods: clearItinerarySupplierFoods,
};

const mapStateToProps = ({ FoodUnit }) => ({
  breadcrumbs: [
    ...FoodUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Alimentaciones por Proveedor',
      href: ITINERARY_SUPPLIER_FOOD_PATH,
    },
  ],
  itinerarySupplierFoods: FoodUnit.ItinerarySupplierFood.getIn([
    'all',
    'content',
  ]),
  loading: FoodUnit.ItinerarySupplierFood.getIn(['all', 'loading']),
});

Suppliers.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  itinerarySupplierFoods: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetItinerarySupplierFoods: PropTypes.func.isRequired,
  dispatchClearItinerarySupplierFoods: PropTypes.func.isRequired,
};

Suppliers.defaultProps = {
  itinerarySupplierFoods: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Suppliers);
